export default "__VITE_ASSET__e171a65f__"